import {
  GET_MINE_UMBRELLA_POSTS,
  GET_MYOREDR_UMBRELLA_PROJECT,
  GET_UMBRELLA_POSTS,
  GET_UMBRELLA_POSTS_BY_ID,
  GET_UMBRELLA_POSTS_LIST_BY_ID,
} from "../constants/index";

export const umbrella = (
  state = {
    myorderumbrellaprojectlist: [],
    umbrellapostlist: [],
    umbrellapostlistmine: [],
    umbrallapostbyid: [],
    umbrellapostlistbyid: [],
  },
  action,
) => {
  switch (action.type) {
    case GET_UMBRELLA_POSTS:
      return { ...state, umbrellapostlist: action.umbrellapostlist };
    case GET_MINE_UMBRELLA_POSTS:
      return { ...state, umbrellapostlistmine: action.umbrellapostlistmine };
    case GET_UMBRELLA_POSTS_BY_ID:
      return { ...state, umbrallapostbyid: action.umbrallapostbyid };
    case GET_UMBRELLA_POSTS_LIST_BY_ID:
      return { ...state, umbrellapostlistbyid: action.umbrellapostlistbyid };
    case GET_MYOREDR_UMBRELLA_PROJECT:
      return {
        ...state,
        myorderumbrellaprojectlist: action.myorderumbrellaprojectlist,
      };
    default:
      return state;
  }
};
